export default function action(type, payload) {
  return {
    type,
    payload,
  };
}



// WEBPACK FOOTER //
// ./js/utils/action.js